import LocalizedStrings from 'react-localization';
import cs from 'static/localization/localization_cs';
import en from 'static/localization/localization_en';
import nb from 'static/localization/localization_nb';
import sk from 'static/localization/localization_sk';

export const Localization = new LocalizedStrings({
    cs,
    en,
    nb,
    sk
});
